 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		36: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"vendors~10crore-layouts-layout~10crore-layouts-layout-header~24betting-layouts-layout~24betting-layo~2c2d4379","2":"vendors~10crore-layouts-layout~10crore-layouts-layout-header~24betting-layouts-layout~24betting-layo~00f254f4","3":"vendors~10crore-layouts-layout~10crore-layouts-layout-header~24betting-layouts-layout~24betting-layo~83cdf548","4":"sportsbook1~sportsbook3~sportsbook4~sportsbook5~sportsbook6~sportsbook7","5":"vendors~sportsbook1~sportsbook3~sportsbook4~sportsbook5~sportsbook6~sportsbook7","7":"default-account-password-change~default-account-responsible-gambling~default-registration","9":"vendors~default-account~default-account-overview","23":"10crore-favicon-ico","24":"10crore-layouts-account","25":"10crore-layouts-layout","26":"10crore-layouts-layout-footer","27":"10crore-layouts-layout-header","28":"21betex-favicon-ico","29":"24bet-favicon-ico","30":"24betting-favicon-ico","31":"24betting-layouts-layout","32":"24betting-layouts-layout-footer","33":"24betting-layouts-layout-header","34":"andarbaharvip-favicon-ico","35":"apostasport-favicon-ico","37":"backlaybet-favicon-ico","38":"balaji8888-favicon-ico","39":"betagain-favicon-ico","40":"betbank-favicon-ico","41":"betbissau-favicon-ico","42":"betbless-favicon-ico","43":"betblu-favicon-ico","44":"betduran-favicon-ico","45":"betexchange365-favicon-ico","46":"betfairasia-favicon-ico","47":"betfairindia-favicon-ico","48":"betflood-favicon-ico","49":"betindialive2-favicon-ico","50":"betkairos-favicon-ico","51":"betlly-favicon-ico","52":"betlux-favicon-ico","53":"betplus365-favicon-ico","54":"betstarexch-favicon-ico","55":"betstarexch-layouts-account","56":"betstarexch-layouts-layout","57":"betstarexch-layouts-layout-footer","58":"bitomania-favicon-ico","59":"bitomania-layouts-layout","60":"bitomania-layouts-layout-footer","61":"bitomania-layouts-layout-header","62":"blackfair-favicon-ico","63":"blackfair-layouts-layout","64":"blackfair-layouts-layout-footer","65":"casino","66":"clubstarexch-favicon-ico","67":"combinadas-favicon-ico","68":"cric247-layouts-layout","69":"cric247-layouts-layout-footer","70":"cric247-layouts-layout-header","71":"crown567-favicon-ico","72":"dailyexch-favicon-ico","73":"dailyexch-layouts-layout","74":"dailyexch-layouts-layout-footer","75":"dailyexch247-favicon-ico","76":"default-account","77":"default-account-achievements","78":"default-account-bets","79":"default-account-money-transfer","80":"default-account-overview","81":"default-account-password-change","82":"default-account-profit-loss","83":"default-account-responsible-gambling","84":"default-account-transactions","85":"default-account-transactions0","86":"default-account-verification","87":"default-account-withdraw","88":"default-confirmation","89":"default-footer","90":"default-header","91":"default-layout","92":"default-login","93":"default-manualdeposit","94":"default-meta","95":"default-password-reset","96":"default-password-update","97":"default-registration","98":"default-static-page","99":"drbetperu-favicon-ico","100":"ebet-favicon-ico","101":"endexch-favicon-ico","102":"exbet24-favicon-ico","103":"exch11-favicon-ico","104":"exchange","105":"fairwaybet-favicon-ico","106":"fancyfair-favicon-ico","107":"findexch-favicon-ico","108":"fireworl-script","109":"freecasinoslots24-favicon-ico","110":"gb24-favicon-ico","111":"gcwinz-favicon-ico","112":"golcash-favicon-ico","113":"highwinbet-favicon-ico","114":"honest-joe-favicon-ico","115":"indiabet24-favicon-ico","116":"indiabet24-layouts-layout","117":"indiabet24-layouts-layout-footer","118":"indiabet24-layouts-layout-header","119":"iworld247-favicon-ico","120":"izzyparyaj-favicon-ico","121":"korectwin-favicon-ico","122":"lapartida-favicon-ico","123":"lovedabet-favicon-ico","124":"lvm365-favicon-ico","125":"lvm999-favicon-ico","126":"mainpage","127":"modules-links","128":"mybetlly-favicon-ico","129":"netflixlike-layouts-layout","130":"netflixlike-layouts-layout-footer","131":"netflixlike-layouts-layout-header","132":"oddswar-favicon-ico","133":"oddswar-layouts-layout","134":"oddswar-layouts-layout-footer","135":"orexch-favicon-ico","136":"pacific2021-layouts-layout","137":"pacific2021-layouts-layout-footer","138":"parlays-board","139":"playcenter-favicon-ico","140":"playingodds-favicon-ico","141":"premiumcricket-favicon-ico","142":"racesfair-favicon-ico","143":"real-win-favicon-ico","144":"realwin-favicon-ico","145":"realwin-layouts-layout","146":"realwin-layouts-layout-footer","147":"realwin-layouts-layout-header","148":"rpsports-favicon-ico","149":"shan999-favicon-ico","150":"sportsbook0","151":"sportsbook1","152":"sportsbook2","153":"sportsbook3","154":"sportsbook4","155":"sportsbook5","156":"sportsbook6","157":"sportsbook7","158":"sportswin247-layouts-layout","159":"sportswin247-layouts-layout-footer","160":"sportswin247-layouts-layout-header","161":"sporway-favicon-ico","162":"super11ex-favicon-ico","163":"testdb-favicon-ico","164":"testdb-layouts-layout","165":"testdb-layouts-layout-footer","166":"testdb-layouts-layout-header","167":"ttexch-favicon-ico","169":"vendors~default-account-overview","170":"vendors~default-account-profit-loss","171":"vendors~default-account-withdraw","172":"vendors~default-layout","173":"whitehorse-favicon-ico","174":"whitehorse-layouts-layout","175":"whitehorse-layouts-layout-footer","176":"win45-favicon-ico","177":"winfairnow-favicon-ico","178":"wonexch-favicon-ico","179":"wst-favicon-ico","180":"xpage365-favicon-ico","181":"xpage888-favicon-ico"}[chunkId]||chunkId) + "-" + "07d991dd256d4ae3f057" + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1316);
